"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AudioVideo_exports = {};
__export(AudioVideo_exports, {
  default: () => AudioVideo_default
});
module.exports = __toCommonJS(AudioVideo_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.1602 2.75C17.6289 2.75 18.026 2.91276 18.3516 3.23828C18.6771 3.5638 18.8398 3.95443 18.8398 4.41016V16.0898C18.8398 16.5456 18.6771 16.9362 18.3516 17.2617C18.026 17.5872 17.6289 17.75 17.1602 17.75H3.83984C3.37109 17.75 2.97396 17.5872 2.64844 17.2617C2.32292 16.9362 2.16016 16.5456 2.16016 16.0898V4.41016C2.16016 3.95443 2.32292 3.5638 2.64844 3.23828C2.97396 2.91276 3.37109 2.75 3.83984 2.75H17.1602ZM17.1602 3.58984H3.83984C3.61849 3.58984 3.42969 3.66146 3.27344 3.80469C3.11719 3.9349 3.02604 4.10417 3 4.3125V4.41016V16.0898C3 16.2982 3.07161 16.4805 3.21484 16.6367C3.35807 16.793 3.53385 16.8841 3.74219 16.9102H3.83984H17.1602C17.3815 16.9102 17.5703 16.8451 17.7266 16.7148C17.8828 16.5716 17.974 16.3958 18 16.1875V16.0898V4.41016C18 4.20182 17.9284 4.01953 17.7852 3.86328C17.6419 3.70703 17.4661 3.61589 17.2578 3.58984H17.1602ZM7.00391 14.4102C7.04297 14.4102 7.07552 14.4297 7.10156 14.4688C7.14062 14.4948 7.16016 14.5339 7.16016 14.5859V15.9141C7.16016 15.9661 7.14062 16.0117 7.10156 16.0508C7.07552 16.0768 7.04297 16.0898 7.00391 16.0898H3.99609C3.95703 16.0898 3.91797 16.0768 3.87891 16.0508C3.85286 16.0117 3.83984 15.9661 3.83984 15.9141V14.5859C3.83984 14.5339 3.85286 14.4948 3.87891 14.4688C3.91797 14.4297 3.95703 14.4102 3.99609 14.4102H7.00391ZM12.0039 14.4102C12.043 14.4102 12.0755 14.4297 12.1016 14.4688C12.1406 14.4948 12.1602 14.5339 12.1602 14.5859V15.9141C12.1602 15.9661 12.1406 16.0117 12.1016 16.0508C12.0755 16.0768 12.043 16.0898 12.0039 16.0898H8.99609C8.95703 16.0898 8.91797 16.0768 8.87891 16.0508C8.85286 16.0117 8.83984 15.9661 8.83984 15.9141V14.5859C8.83984 14.5339 8.85286 14.4948 8.87891 14.4688C8.91797 14.4297 8.95703 14.4102 8.99609 14.4102H12.0039ZM17.0039 14.4102C17.043 14.4102 17.0755 14.4297 17.1016 14.4688C17.1406 14.4948 17.1602 14.5339 17.1602 14.5859V15.9141C17.1602 15.9661 17.1406 16.0117 17.1016 16.0508C17.0755 16.0768 17.043 16.0898 17.0039 16.0898H13.9961C13.957 16.0898 13.918 16.0768 13.8789 16.0508C13.8529 16.0117 13.8398 15.9661 13.8398 15.9141V14.5859C13.8398 14.5339 13.8529 14.4948 13.8789 14.4688C13.918 14.4297 13.957 14.4102 13.9961 14.4102H17.0039ZM12.1602 7.75C12.3945 7.75 12.5898 7.83464 12.7461 8.00391C12.9154 8.16016 13 8.35547 13 8.58984C13 8.8112 12.9154 9.00651 12.7461 9.17578C12.5898 9.33203 12.3945 9.41016 12.1602 9.41016H11.3398V11.5C11.3398 11.8516 11.2161 12.151 10.9688 12.3984C10.7214 12.6328 10.4284 12.75 10.0898 12.75C9.73828 12.75 9.4388 12.6328 9.19141 12.3984C8.95703 12.151 8.83984 11.8516 8.83984 11.5C8.83984 11.1484 8.95703 10.8555 9.19141 10.6211C9.4388 10.3737 9.73828 10.25 10.0898 10.25C10.1549 10.25 10.2201 10.2565 10.2852 10.2695C10.3633 10.2826 10.4349 10.3021 10.5 10.3281V8.16016C10.5 8.04297 10.5391 7.94531 10.6172 7.86719C10.6953 7.78906 10.793 7.75 10.9102 7.75C10.9492 7.75 10.9818 7.75651 11.0078 7.76953C11.0339 7.76953 11.0599 7.77604 11.0859 7.78906C11.125 7.77604 11.1641 7.76953 11.2031 7.76953C11.2422 7.75651 11.2878 7.75 11.3398 7.75H12.1602ZM7.00391 4.41016C7.04297 4.41016 7.07552 4.42969 7.10156 4.46875C7.14062 4.49479 7.16016 4.53385 7.16016 4.58594V5.91406C7.16016 5.96615 7.14062 6.01172 7.10156 6.05078C7.07552 6.07682 7.04297 6.08984 7.00391 6.08984H3.99609C3.95703 6.08984 3.91797 6.07682 3.87891 6.05078C3.85286 6.01172 3.83984 5.96615 3.83984 5.91406V4.58594C3.83984 4.53385 3.85286 4.49479 3.87891 4.46875C3.91797 4.42969 3.95703 4.41016 3.99609 4.41016H7.00391ZM12.0039 4.41016C12.043 4.41016 12.0755 4.42969 12.1016 4.46875C12.1406 4.49479 12.1602 4.53385 12.1602 4.58594V5.91406C12.1602 5.96615 12.1406 6.01172 12.1016 6.05078C12.0755 6.07682 12.043 6.08984 12.0039 6.08984H8.99609C8.95703 6.08984 8.91797 6.07682 8.87891 6.05078C8.85286 6.01172 8.83984 5.96615 8.83984 5.91406V4.58594C8.83984 4.53385 8.85286 4.49479 8.87891 4.46875C8.91797 4.42969 8.95703 4.41016 8.99609 4.41016H12.0039ZM17.0039 4.41016C17.043 4.41016 17.0755 4.42969 17.1016 4.46875C17.1406 4.49479 17.1602 4.53385 17.1602 4.58594V5.91406C17.1602 5.96615 17.1406 6.01172 17.1016 6.05078C17.0755 6.07682 17.043 6.08984 17.0039 6.08984H13.9961C13.957 6.08984 13.918 6.07682 13.8789 6.05078C13.8529 6.01172 13.8398 5.96615 13.8398 5.91406V4.58594C13.8398 4.53385 13.8529 4.49479 13.8789 4.46875C13.918 4.42969 13.957 4.41016 13.9961 4.41016H17.0039Z",
      fill: "currentColor"
    }
  )
);
const SvgAudioVideo = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var AudioVideo_default = SvgAudioVideo;
